import { debounce, throttle } from '../../util/tools';
import handleAjaxPageLoad from '../ajax-page';
import {enableAjaxLoad} from '../site';

export default function collectionFiltersInit (filters) {
  const filtersEl = filters.querySelectorAll('.filters-filter');
  const search = filters.querySelector('.filters-search');
  const reset = filters.querySelector('.filters-reset a');

  search.addEventListener(
    'keyup',
    debounce(e => {
      if (window.innerWidth < 960) {
        if (e.code === 'Enter') {
          enableLoader(filters);
          createRequest(search, e, filters);
        }
      } else {
        enableLoader(filters);
        createRequest(search, e, filters);
      }
    }, 1000)
  );

  reset.addEventListener('mousedown', e => resetFilters(filters));

  filtersEl.forEach(el => {
    el.addEventListener('change', e => createRequest(el, e, filters));
  });

  let allDisabled = true;
  filtersEl.forEach(el => {
    if (!(el.value === 'all' || el.value === '')) {
      allDisabled = false;
    }
  });
  if (allDisabled) {
    filters.querySelector('.filters-reset').classList.add('disabled');
  }
}

function enableLoader (filters) {
  const loader = filters.querySelector('.loading-spinner');
  loader.classList.remove('disabled');
}

function createRequest (filterEl, e, filters) {
  filters.querySelector('.filters-reset').classList.remove('disabled');
  const filtersArr = filters.querySelectorAll('.filters-filter');
  filtersArr.forEach(el => {
    if (el !== filterEl) {
      resetFilter(el);
    }
  });

  if (e.target && e.target.value) {
    const value = encodeURIComponent(e.target.value);
    filterEl.dataset.href = `${filterEl.dataset.action}/${
      filterEl.dataset.filter
    }/${value}`;
  } else {
    filterEl.dataset.href = `${filterEl.dataset.action}`;
  }

  var modifier = e.shiftKey || e.ctrlKey || e.metaKey;
  if (enableAjaxLoad && !modifier) {
    handleAjaxPageLoad(filterEl, 'collection-product');
  } else if (window.innerWidth < 960) {
    window.location = filterEl.dataset.href;
  }
}

function resetFilters (filters) {
  const filtersArr = filters.querySelectorAll('.filters-filter');
  filtersArr.forEach(el => {
    resetFilter(el);
  });
  createRequest(filters.querySelector('.filters-reset a'), {}, filters);
  filters.querySelector('.filters-reset').classList.add('disabled');
}

function resetFilter (el) {
  if (el.options) {
    let defaultText = el.options[0];
    let label =
      el.nextSibling.nodeName.toUpperCase() === 'SPAN'
        ? el.nextSibling
        : false;
    if (label) {
      label.innerHTML = defaultText.innerHTML;
    }
  } else {
    el.value = '';
  }
}



// WEBPACK FOOTER //
// ./assets/j/src/collection/filters.js